import Loader from '@anm/components/Loader';
import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  margin-bottom: 20px;

  button,
  input {
    height: 40px;
    line-height: 40px;
  }

  input {
    color: #292a2b;
  }

  button {
    flex-shrink: 0;
    font-size: 14px;
  }
`;

export const LoaderWrapper = styled(Loader)`
  margin: 10px auto;
`;
